import { render, staticRenderFns } from "./packViewVip.vue?vue&type=template&id=00e298a9&"
import script from "./packViewVip.vue?vue&type=script&lang=js&"
export * from "./packViewVip.vue?vue&type=script&lang=js&"
import style0 from "./packViewVip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e298a9')) {
      api.createRecord('00e298a9', component.options)
    } else {
      api.reload('00e298a9', component.options)
    }
    module.hot.accept("./packViewVip.vue?vue&type=template&id=00e298a9&", function () {
      api.rerender('00e298a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/packViewVip.vue"
export default component.exports